<template>
    <div id="category-form-wrapper">
        <accordion-section title="Main Information" startOpen>
            <b-field v-for="(field, index) in fields" :key="`attribute-field-${field.code}`" horizontal :label="field.name">
                <b-field>
                    <b-input v-model="input[field.code]" :disabled="field.updatable || !field.editable" :type="field.type"></b-input>
                    <template v-slot:message>
                        <span class="is-flex is-align-items-center is-justify-content-space-between">
                            <span v-if="field.isDefault">Default value.</span>
                            <span style="margin-left: auto" v-if="field.updatable">Value controlled from source.</span>
                            <b-switch v-if="store !== 1" style="margin-left: auto" v-model="fields[index].editable">Update for store?</b-switch>
                        </span>
                    </template>
                </b-field>
            </b-field>

            <div class="section is-flex">

            <b-button tag="button"
                      type="is-primary"
                      class="is-uppercase mt-3"
                      :label="creating ? 'Create' : 'Save'"
                      outlined rounded style="margin-left: auto"
                      @click.prevent="submit"></b-button>
            </div>
        </accordion-section>
    </div>
</template>
<script>
    export default {
        props: {
            category: {
                required: true,
                type: Object
            },
            parentId: {
                required: false,
                type: Number,
                default: 0
            },
            creating: {
                required: false,
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                loading: true,
                attributes: [],
                fields: [],
                input: {},
                inputTypeMapping: {
                    string: 'text',
                    text: 'textarea'
                },
                store: 1
            }
        },
        mounted() {
            this.store = this.$route.params.hasOwnProperty('store')
                ? parseInt(this.$route.params.store)
                : 1;

            axios.get('/attribute/filter', {params: {entity_type: 'category'}})
                .then(response => {
                    this.attributes = response.data;
                    this.assignData();
                    this.loading = false
                })
        },
        methods: {
            assignData() {
                this.$set(this, 'fields', [])
                let categoryAttributes = this.category.attribute_values;

                for (let attribute of this.attributes) {
                    this.$set(this.input, attribute.code, this.category[attribute.code])
                    let attributesPerStore = _.filter(categoryAttributes, {code: attribute.code})
                    let field = {
                        name: attribute.name,
                        code: attribute.code,
                        type: this.inputTypeMapping[attribute.type],
                        isDefault: false,
                        editable: false
                    }

                    if (this.store === 1) {
                        field.editable = true;
                        this.fields.push(field)
                        continue;
                    }

                    if (attributesPerStore.length === 1 || !attributesPerStore.length) {
                        field.isDefault = true;
                    }

                    let attributeForStore = _.find(attributesPerStore, attr => {return attr.pivot.store_id === this.store})
                    if (attributeForStore) {
                        field.editable = true;
                    }

                    this.fields.push(field)
                }

                if (this.creating) {
                    this.$set(this.input, 'parent_id', this.parentId)
                } else {
                    this.$set(this.input, 'parent_id', this.category.parent_id)
                }
            },
            submit() {
                let endpoint = this.creating ? '/store/category' : `/update/category/${this.category.id}`;
                let method = this.creating ? 'post' : 'patch';

                axios({method, url: endpoint, data: this.input})
                    .then(response => {
                        let translationKey = this.creating ? 'messages.model.created' : 'messages.model.updated'
                        let message = this.__(translationKey, {name: this.__('strings.models.category')})
                        if (this.creating) {
                            this.$router.push({name: 'model.action', params: {resource: 'category', action: 'edit', routeKey: response.data.id}})
                        }
                        this.$emit('updated', response.data);
                        this.toaster(message, "is-success");
                    })
                    .catch(error => {
                        // this.errors = error.response.data.errors;
                        this.toaster("There was an error with your request", "is-danger")
                    })
            },
            toaster(message, type) {
                this.$buefy.snackbar.open({
                    message,
                    type,
                    position: 'is-bottom-right',
                    actionText: 'Ok',
                })
            }
        },
        watch: {
            category() {
                this.assignData();
            }
        }
    }
</script>